import { useSelector } from 'react-redux';
import { useIsFeatureEnabled } from 'src/hooks';
import { SYSTEM_PERMISSIONS } from 'src/permissionsTypes';
import { permissionsCheck } from 'src/utils/permissionChecks';
import * as Types from '../../types';

export const AuthorisedCaseImporter = () => {
  const caseImporterEnabled = useIsFeatureEnabled(
    Types.FeatureFlag.CASE_IMPORTER,
  );
  const isSpeakUpEnabled = useIsFeatureEnabled(Types.FeatureFlag.SPEAK_UP);
  const systemPermissions = useSelector(
    (state: Types.State) => state.globalUsers.currentUser?.systemPermissions,
  );

  if (!systemPermissions) {
    return false;
  }

  const hasAdministerAllCases = permissionsCheck(systemPermissions, [
    SYSTEM_PERMISSIONS.ADMINISTER_ALL_CASES,
  ]);
  const hasAdministerNonOffenderCases = permissionsCheck(systemPermissions, [
    SYSTEM_PERMISSIONS.ADMINISTER_NON_OFFENDER_CASES,
  ]);
  const hasAdministerPermission =
    hasAdministerAllCases || hasAdministerNonOffenderCases;

  const hasCreateExistingReport = permissionsCheck(systemPermissions, [
    SYSTEM_PERMISSIONS.CREATE_EXISTING_REPORT,
  ]);
  const hasCreateNewReport = permissionsCheck(systemPermissions, [
    SYSTEM_PERMISSIONS.CREATE_NEW_REPORT,
  ]);
  const hasCreatePermission = hasCreateExistingReport || hasCreateNewReport;

  const hasRequiredPermissions = permissionsCheck(systemPermissions, [
    SYSTEM_PERMISSIONS.NAV_CASES,
    SYSTEM_PERMISSIONS.EDIT_ALL_CASES,
    SYSTEM_PERMISSIONS.LIST_ALL_CASES,
  ]);

  const hasCaseImportPermissions =
    hasAdministerPermission && hasCreatePermission && hasRequiredPermissions;

  return isSpeakUpEnabled && caseImporterEnabled && hasCaseImportPermissions;
};
